export default __webpack_public_path__ + "static/media/gg.4c6152c3.svg";